import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function GenericQuote() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    service_slug: "motorhome-removal", full_name: "", email: "", phone: "", city: "", state: "", description: "", estimated_units: 1,
  });

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/quotes", form);
      toast.success("Quote submitted. Disposal dispatch will contact you within 24 hours.");
      navigate("/");
    } catch { toast.error("Could not submit."); }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 py-20" data-testid="generic-quote-page">
      <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706]">// Disposal Intake</div>
      <h1 className="display-black text-4xl lg:text-5xl uppercase text-[#064E3B] mt-3 tracking-tighter">Request a quote</h1>
      <p className="text-gray-700 mt-2">Any service. Any city. We'll route you to the right division.</p>

      <form onSubmit={submit} className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5 border border-gray-300 p-8" data-testid="generic-quote-form">
        <select className="input-federal md:col-span-2" value={form.service_slug} onChange={e => setForm({...form, service_slug: e.target.value})} data-testid="gq-service">
          <option value="motorhome-removal">Motorhome Removal</option>
          <option value="rv-disposal">RV Disposal</option>
          <option value="camper-removal">Camper Removal</option>
          <option value="boat-removal">Boat Removal</option>
          <option value="semi-trailer-removal">Semi-Trailer Removal</option>
          <option value="bus-prevost-removal">Bus / Prevost Removal</option>
          <option value="airplane-removal">Airplane Disposal</option>
          <option value="helicopter-removal">Helicopter Removal</option>
          <option value="real-property-removal">Real Property Removal</option>
          <option value="squatter-removal">Squatter Removal</option>
        </select>
        <input className="input-federal" required placeholder="Full name" value={form.full_name} onChange={e => setForm({...form, full_name: e.target.value})} data-testid="gq-name" />
        <input className="input-federal" required type="email" placeholder="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} data-testid="gq-email" />
        <input className="input-federal" required placeholder="Phone" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} data-testid="gq-phone" />
        <input className="input-federal" type="number" min={1} placeholder="Units" value={form.estimated_units} onChange={e => setForm({...form, estimated_units: parseInt(e.target.value)||1})} data-testid="gq-units" />
        <input className="input-federal" placeholder="City" value={form.city} onChange={e => setForm({...form, city: e.target.value})} data-testid="gq-city" />
        <input className="input-federal" placeholder="State / Province" value={form.state} onChange={e => setForm({...form, state: e.target.value})} data-testid="gq-state" />
        <textarea className="input-federal md:col-span-2" rows={5} required placeholder="Describe the asset, location, urgency…" value={form.description} onChange={e => setForm({...form, description: e.target.value})} data-testid="gq-description" />
        <button type="submit" className="btn-federal md:col-span-2 justify-center" data-testid="gq-submit">Submit <ArrowRight className="w-4 h-4" /></button>
      </form>
    </div>
  );
}
